import { Box, Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import type { TimelineItemResponseDTO as TimelineItem } from "web_myplann/Infrastructure/Api/Api";
import { TimelineEntry } from "web_myplann/NotificationCenter/Components/TimelineEntry";
import { NOTIFICATION_CENTER_TABS } from "web_myplann/NotificationCenter/Constants/notificationCenterTabs";
import type { RecentGroup } from "web_myplann/NotificationCenter/Utils/groupTypes";

interface RecentGroupSectionProps {
	group: RecentGroup;
	onItemClick: (item: TimelineItem) => void;
}

export const RecentGroupSection: FC<RecentGroupSectionProps> = ({
	group,
	onItemClick,
}) => {
	const theme = useTheme();

	return (
		<Stack
			data-testid={`recent-group-${group.key}`}
			sx={{ backgroundColor: theme.palette.grey[100] }}
		>
			<Typography
				fontSize={11}
				fontWeight={600}
				color={theme.palette.grey[600]}
				sx={{
					textTransform: "uppercase",
					letterSpacing: 0.5,
					px: 1.6,
					pt: 1.2,
					pb: 0.8,
				}}
			>
				{group.label}
			</Typography>
			<Box sx={{ mb: 1.2 }}>
				{group.items.map((item, index) => (
					<TimelineEntry
						key={item.id}
						item={item}
						tab={NOTIFICATION_CENTER_TABS.Recent}
						onClick={onItemClick}
						isLast={index === group.items.length - 1}
					/>
				))}
			</Box>
		</Stack>
	);
};
